module.exports = __webpack_public_path__ + "img/4.9c627ce1.jpeg";